/**
 * URL d'une copie réduite servie par le proxy d'images (03/11/2026).
 *
 * Seules les images passées par ``/api/images/`` savent se réduire (``?w=``,
 * largeurs fixes côté serveur) ; toute autre URL est rendue telle quelle.
 * Prendre une largeur ≈ 2 × la taille affichée (écrans haute densité).
 */
export const LARGEURS = [96, 176, 352, 480];

export function imageReduite(url, largeur) {
  if (!url || typeof url !== "string" || !url.includes("/api/images/")) return url;
  if (!LARGEURS.includes(largeur) || url.includes("?")) return url;
  return `${url}?w=${largeur}`;
}
